import { Helmet } from 'react-helmet'

import type {
  Component,
  SidebarComponent,
  SocialMetaData,
  CommentTopics,
} from 'services/content/types'
import Loader from 'content-components/_Primatives/Loader'
import ResumeCourseBanner from 'ui-component-library/components/ResumeCourseBanner'
import SocialMetadata from 'ui-component-library/components/SocialSharing/SocialMetadata'
import { isPreRendering } from 'ui-component-library/utils/helpers'
import Footer from 'containers/Footer'
import Header from 'containers/Header'
import PolicyBanner from 'containers/PolicyBanner'
import MainContent from 'components/MainContent'

type Props = {
  components: Component[]
  sidebarComponents?: SidebarComponent[]
  commentTopics?: CommentTopics
  isLoadingBase: boolean
  isLoadingPage: boolean
  isOnOrderSuccessPages: boolean
  socialMetaData: SocialMetaData
  title: string
  isRegisteredForOnRamp?: boolean
  resumeCourseBannerStrings: {
    bodyText: string
    link: {
      text: string
      url: string
    }
  }
}

function App({
  sidebarComponents,
  components,
  isLoadingBase,
  isLoadingPage,
  socialMetaData,
  title,
  isRegisteredForOnRamp,
  isOnOrderSuccessPages,
  resumeCourseBannerStrings,
  commentTopics,
}: Props) {
  return isLoadingBase ? (
    <Loader />
  ) : (
    <>
      <Helmet>
        <title>
          CrossFit
          {title ? ` | ${title}` : ''}
        </title>
      </Helmet>
      <SocialMetadata {...socialMetaData} />
      <Header />

      {isRegisteredForOnRamp && !isOnOrderSuccessPages && (
        <ResumeCourseBanner {...resumeCourseBannerStrings} />
      )}

      <MainContent
        sidebarComponents={sidebarComponents}
        commentTopics={commentTopics}
        components={components}
        isLoading={isLoadingPage}
      />

      <Footer />
      {!isPreRendering() && <PolicyBanner />}
    </>
  )
}

export default App
